import Decorate from "@tencent/spaui-decorate"
import { Dialog } from "@tencent/spaui"
import _ from "lodash"

const modalDialog = new Decorate(Dialog)

let outsideResolve
let outsideReject = _.noop

function close() {
  modalDialog.setProps({
    show: false,
  })
  outsideResolve && outsideResolve()
}

export const genMsgFun = (type) => (children, options = { time: 4000 }) => {
  const { onSubmit } = options
  return new Promise((resolve, reject) => {
    outsideResolve = resolve
    outsideReject = reject
    modalDialog.setProps({
      show: true,
      title: "提示",
      children,
      onClose() {
        modalDialog.setProps({
          show: false,
        })
        resolve()
      },
      onCancel() {
        modalDialog.setProps({
          show: false,
        })
      },
      type: "normal",
      style: { width: "450px" },
      ...options,
      onSubmit: () => {
        if (onSubmit) {
          onSubmit(close)
        } else {
          close()
        }
      },
    })
  })
}

const modal = {
  strongwarn: genMsgFun("strongwarn"),
  error: genMsgFun("error"),
  info: genMsgFun("info"),
  loading: genMsgFun("loading"),
  success: genMsgFun("success"),
  warn: genMsgFun("warn"),
  close,
}

export default modal
